export default __webpack_public_path__ + "static/media/78_desktop.50e7434a.jpg";